import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { useSynapse } from 'app/lib/synaptik';
import { Alert, Flex, Button, Container, Formbot, Form, Input, Text } from '@goodrx/matisse';
import qs from 'qs';
import { PageHeading } from 'app/components/PageHeading';
import DocumentTitle from 'app/components/core/document-title';

function ResetPassword({ history, location }: any) {
  const [resetToken, setResetToken] = useState();
  const [resetError, setResetError] = useState<string>();
  const [resetPassword, resettingPassword] = useSynapse(({ user }) => [
    user.resetPassword,
    user.state.resettingPassword,
  ]);

  useEffect(() => {
    const search = location.search.replace(/^\?/, '');
    const { token } = qs.parse(search);

    if (!token) {
      history.push('/login');
    } else {
      setResetToken(token);
    }
  }, []);

  async function handleSubmit({ values, isValid }: any) {
    if (!isValid) {
      return;
    }

    const { password, passwordConfirm } = values;
    if (password !== passwordConfirm) {
      setResetError('Passwords do not match');
      return;
    }

    try {
      await resetPassword({ token: resetToken, password });
      history.push('/login', location.state);
    } catch (err) {
      const status = err.response && err.response.status;
      if (status === 401 || status === 403) {
        history.push('/forgot-password');
      }
    }
  }

  return (
    <Container maxWidth={450}>
      <DocumentTitle titleKey="ResetPassword" />
      <PageHeading
        title="Reset Your Password"
        subtitle="Password must be 8 characters and include at least 1 capital letter, 1 lowercase letter and a number."
      />

      <Formbot
        initialValues={{
          email: location.state && location.state.email,
        }}
        validations={{
          password: { required: true },
          passwordConfirm: { required: true },
        }}
        onSubmit={handleSubmit}>
        <Form>
          {resetError && (
            <Alert data-qa="reset_error_alert" variant="danger">
              {resetError}
            </Alert>
          )}
          <Input type="password" name="password" label="New Password" floating />
          <Input type="password" name="passwordConfirm" label="Confirm Password" floating />

          <Button mt={4} block size="lg" type="submit" loading={resettingPassword}>
            Submit
          </Button>

          <Flex justifyContent="space-between" mt={4} fontSize={14}>
            <Link to="/login">Back To Login</Link>

            <Text color="greyDarkest">
              Don&apos;t have an account? <Link to="/register">Sign Up</Link>
            </Text>
          </Flex>
        </Form>
      </Formbot>
    </Container>
  );
}

export default withRouter(ResetPassword);
